.ap{flex-shrink:0;}